"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mercedesActionStyle = exports.mercedesSecondaryStyle = exports.mercedesCtaStyle = exports.mercedesColors = exports.mercedesTheme = exports.fontColor = exports.getColorGradients = exports.getColors = exports.hasVariant = exports.mercedesCtaColors = exports.mercedesFontLight = exports.mercedesFontDark = void 0;
var tslib_1 = require("tslib");
var styled_components_1 = require("styled-components");
var Cta_styled_1 = require("../Cta.styled");
var common_styles_1 = require("@next-components/common-styles");
var polished_1 = require("polished");
exports.mercedesFontDark = common_styles_1.mercedesColor.gunmetal;
exports.mercedesFontLight = common_styles_1.mercedesColor.white;
exports.mercedesCtaColors = {
    brand: {
        color: common_styles_1.mercedesColor.buttonGradientStart,
        gradient: common_styles_1.buttonGradient,
    },
    light: {
        color: common_styles_1.mercedesColor.buttonLightGradientStart,
        gradient: common_styles_1.buttonLightGradient,
    },
    blue: {
        color: common_styles_1.mercedesColor.buttonBlueGradientStart,
        gradient: common_styles_1.buttonBlueGradient,
    },
};
exports.hasVariant = function (colorVariant) { return ['brand', 'light', 'blue'].includes(colorVariant); };
exports.getColors = function (colorVariant, colors) {
    if (colors === void 0) { colors = exports.mercedesCtaColors; }
    return exports.hasVariant(colorVariant) ? colors[colorVariant].color : colorVariant;
};
exports.getColorGradients = function (colorVariant, colors) {
    if (colors === void 0) { colors = exports.mercedesCtaColors; }
    return exports.hasVariant(colorVariant) ? colors[colorVariant].gradient : colorVariant;
};
exports.fontColor = function (props) {
    return polished_1.desaturate(props.disabled ? 1 : 0, polished_1.getLuminance(exports.getColors(props.colorVariant)) > 0.5 ? exports.mercedesFontDark : exports.mercedesFontLight);
};
var paddingHorizontal = '0.625rem';
var paddingVertical = '0.75rem';
var getHover = function (colorVariant) {
    switch (colorVariant) {
        case 'brand':
            return "linear-gradient(180deg, #4b4b4b 0%, #3b3b3b 100%)";
        case 'light':
            return "linear-gradient(180deg, #E5E5E5 0%, #CDCDCD 100%)";
        case 'blue':
            return "linear-gradient(180deg, #0088C6 0%, #066EA4 100%)";
        default:
            return null;
    }
};
var getDisabledBackground = function (colorVariant) {
    switch (colorVariant) {
        case 'brand':
            return "linear-gradient(180deg, #9D9D9D 0%, #8C8C8C 100%)";
        case 'light':
            return "linear-gradient(180deg, #FBFBFB 0%, #EBEBEB 100%)";
        case 'blue':
            return "linear-gradient(180deg, #4DC6F4 0%, #53ACD2 100%)";
        default:
            return null;
    }
};
var getDisabledText = function (colorVariant) {
    switch (colorVariant) {
        case 'brand':
            return '#BFBFBF';
        case 'light':
            return '#ABABAB';
        case 'blue':
            return '#B8E8FB';
        default:
            return null;
    }
};
exports.mercedesTheme = styled_components_1.css(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  height: 43px;\n  padding: ", " ", ";\n  border-radius: 2px;\n  border: none;\n\n  span {\n    font-family: ", ";\n    font-weight: ", ";\n    letter-spacing: 0.01em;\n\n    ", " {\n      font-size: 1rem;\n    }\n  }\n"], ["\n  height: 43px;\n  padding: ", " ", ";\n  border-radius: 2px;\n  border: none;\n\n  span {\n    font-family: ", ";\n    font-weight: ", ";\n    letter-spacing: 0.01em;\n\n    ", " {\n      font-size: 1rem;\n    }\n  }\n"])), paddingVertical, paddingHorizontal, common_styles_1.typography.type.mbSub, common_styles_1.typography.weight.light, common_styles_1.responsive.xsMax);
exports.mercedesColors = styled_components_1.css(templateObject_2 || (templateObject_2 = tslib_1.__makeTemplateObject(["\n  background: ", ";\n  color: ", ";\n\n  & svg {\n    fill: ", ";\n  }\n"], ["\n  background: ", ";\n  color: ", ";\n\n  & svg {\n    fill: ", ";\n  }\n"])), function (_a) {
    var colorVariant = _a.colorVariant;
    return exports.getColorGradients(colorVariant);
}, exports.fontColor, exports.fontColor);
// CTA styling
exports.mercedesCtaStyle = styled_components_1.css(templateObject_3 || (templateObject_3 = tslib_1.__makeTemplateObject(["\n  background: ", ";\n  color: ", ";\n  transition: background-color ", " ease-in-out, color ", " ease-in-out,\n    fill ", " ease-in-out, border-color ", " ease-in-out;\n\n  &:hover:not(:disabled) {\n    background: ", ";\n  }\n  &:disabled {\n    background: ", ";\n    color: ", ";\n  }\n"], ["\n  background: ", ";\n  color: ", ";\n  transition: background-color ", " ease-in-out, color ", " ease-in-out,\n    fill ", " ease-in-out, border-color ", " ease-in-out;\n\n  &:hover:not(:disabled) {\n    background: ", ";\n  }\n  &:disabled {\n    background: ", ";\n    color: ", ";\n  }\n"])), function (_a) {
    var colorVariant = _a.colorVariant;
    return exports.getColorGradients(colorVariant);
}, exports.fontColor, Cta_styled_1.animationTime, Cta_styled_1.animationTime, Cta_styled_1.animationTime, Cta_styled_1.animationTime, function (_a) {
    var colorVariant = _a.colorVariant;
    return getHover(colorVariant);
}, function (_a) {
    var colorVariant = _a.colorVariant;
    return getDisabledBackground(colorVariant);
}, function (_a) {
    var colorVariant = _a.colorVariant;
    return getDisabledText(colorVariant);
});
var outlineVariants = styled_components_1.css(templateObject_4 || (templateObject_4 = tslib_1.__makeTemplateObject(["\n  background: ", ";\n  color: ", ";\n  & svg {\n    fill: ", ";\n  }\n  &:disabled {\n    border-color: ", ";\n    color: ", ";\n  }\n"], ["\n  background: ", ";\n  color: ", ";\n  & svg {\n    fill: ", ";\n  }\n  &:disabled {\n    border-color: ", ";\n    color: ", ";\n  }\n"])), function (_a) {
    var colorVariant = _a.colorVariant;
    return exports.getColorGradients(colorVariant);
}, function (_a) {
    var backgroundDark = _a.backgroundDark;
    return (backgroundDark ? exports.mercedesFontLight : exports.mercedesFontDark);
}, function (_a) {
    var backgroundDark = _a.backgroundDark;
    return (backgroundDark ? exports.mercedesFontLight : exports.mercedesFontDark);
}, common_styles_1.bosColor.neutralGrey, common_styles_1.bosColor.neutralPlus);
exports.mercedesSecondaryStyle = styled_components_1.css(templateObject_5 || (templateObject_5 = tslib_1.__makeTemplateObject(["\n  ", ";\n  ", ";\n  &:hover:not(:disabled) {\n    background: ", ";\n    color: ", ";\n    border-color: ", ";\n    & svg {\n      fill: ", ";\n    }\n  }\n  &:disabled {\n    border-color: ", ";\n  }\n"], ["\n  ", ";\n  ", ";\n  &:hover:not(:disabled) {\n    background: ", ";\n    color: ", ";\n    border-color: ", ";\n    & svg {\n      fill: ", ";\n    }\n  }\n  &:disabled {\n    border-color: ", ";\n  }\n"])), exports.mercedesCtaStyle, outlineVariants, function (_a) {
    var colorVariant = _a.colorVariant;
    return polished_1.darken(0.05, exports.getColors(colorVariant));
}, exports.fontColor, function (_a) {
    var colorVariant = _a.colorVariant;
    return polished_1.darken(0.05, exports.getColors(colorVariant));
}, exports.fontColor, common_styles_1.bosColor.neutralGrey);
// Trenger vi denne senere?
exports.mercedesActionStyle = styled_components_1.css(templateObject_6 || (templateObject_6 = tslib_1.__makeTemplateObject(["\n  ", ";\n\n  border: none;\n  border-bottom: 3px solid;\n  border-radius: 0;\n  padding-bottom: calc(", " - 3px);\n  padding-left: 0.125rem;\n  padding-right: 0.125rem;\n\n  transition: border-width ", " ease-in-out, padding-bottom ", " ease-in-out;\n  border-color: ", ";\n\n  &:hover:not(:disabled) {\n    padding-bottom: calc(", " - 6px);\n    border-width: 6px;\n  }\n"], ["\n  ", ";\n\n  border: none;\n  border-bottom: 3px solid;\n  border-radius: 0;\n  padding-bottom: calc(", " - 3px);\n  padding-left: 0.125rem;\n  padding-right: 0.125rem;\n\n  transition: border-width ", " ease-in-out, padding-bottom ", " ease-in-out;\n  border-color: ", ";\n\n  &:hover:not(:disabled) {\n    padding-bottom: calc(", " - 6px);\n    border-width: 6px;\n  }\n"])), outlineVariants, paddingVertical, Cta_styled_1.animationTime, Cta_styled_1.animationTime, function (_a) {
    var colorVariant = _a.colorVariant;
    return polished_1.darken(0.05, exports.getColors(colorVariant));
}, paddingVertical);
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;
//# sourceMappingURL=mercedes.js.map